import browser from "./browser";
import node from "./node";

export const posthogPlugin = typeof window === "undefined" ? node : browser;
